import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Payment QA',
        },
    },
    component: PaymentQA,
});

function PaymentQA() {
    return <PageController route={Route}>This tab is under construction</PageController>;
}
